export default {
  API_URL: "/api",
  LIVE_UPDATE_INTERVAL: 30000,
  GRAPH_HIDDEN_COLUMNS: [0, 1, 2, 3],
  GRAPH_DEFAULT_ENABLED_COLUMNS: [4, 5, 7],
  TABLE_COLUMNS: [1, 3, 2, 4, 5, 6, 18, 19],
  TABLE_RECORDS_LIMIT: 1000
}
